import Logger from "./external/logger";
import env from '../utils/env';

// Minimal shape of the legacy WebSQL database, kept local since
// `expo-sqlite/legacy` was removed in SDK 53. On web the only value ever
// passed here is EMPTY_DB, so this stub is sufficient.
type WebSQLTransaction = {
  executeSql: (
    query: string,
    params: (string | number)[],
    success: (tx: WebSQLTransaction, output: { rows: { _array: any[] } }) => void
  ) => void;
};
type WebSQLDatabase = {
  transaction: (
    cb: (tx: WebSQLTransaction) => void,
    error: (e: any) => void,
    success: () => void
  ) => void;
};

//@ts-ignore
const logger = new Logger(env.LOGGER_TOKEN)

export const writeDBFile = async (dbUri: string) => {
  return
}

export const EMPTY_DB = {
  transaction: () => {
    return {
      executeSql: () => { },
    };
  },
};

export async function openDatabase() {
  return EMPTY_DB
}


export const simpleTransaction: (db: WebSQLDatabase, query: string, params: (string | number)[]) => Promise<any | undefined> = (db: WebSQLDatabase, query: string, params: (string | number)[]) => {
  return new Promise((resolve, reject) => db.transaction(
    (tx) => {
      tx.executeSql(
        query,
        params,
        (_, output) => {
          resolve(output.rows._array)

        }
      );
    },
    (e) => {
      reject(e)
    },
    () => {
      // console.log("success")
    }))
}
